import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  TextField,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  IconButton,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { ExpandMore, Sort } from '@mui/icons-material';
import flaskServer from '../config/flaskserver';

const LogViewer = ({ isUserAdminn}) => {
  const [logs, setLogs] = useState([]);
  const [filter, setFilter] = useState('');
  const [sortOrder, setSortOrder] = useState('asc');
  const [activeUsers, setActiveUsers] = useState([]); 
  const [dialogOpen, setDialogOpen] = useState(false); 

  const token = localStorage.getItem('token');

  const fetchLogs = async () => {
    try {
      const response = await axios.get(`${flaskServer.flaskServerIP}/logs`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (Array.isArray(response.data)) {
        setLogs(response.data);
      } else {
        
      }
    } catch (err) {
      
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchActiveUsers = async () => {
    try {
      const response = await axios.get(`${flaskServer.flaskServerIP}/active-users`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      

      if (response.data && Array.isArray(response.data.active_users)) {
        const activeUsersArray = response.data.active_users;
        
        setActiveUsers(activeUsersArray);
        
        setDialogOpen(true);
      } else {
        
      }
    } catch (err) {
      
    }
  };

  const applyFilters = (log, filters) => {
    const filterArray = filters.split(';').map(f => f.trim().toLowerCase());
    return filterArray.every(
      filter =>
        log.log.join('\n').toLowerCase().includes(filter) || log.file.toLowerCase().includes(filter)
    );
  };

  const filteredLogs = Array.isArray(logs) ? logs.filter(log => applyFilters(log, filter)) : [];

  const sortedLogs = filteredLogs.sort((a, b) => {
    if (sortOrder === 'asc') {
      return a.file.localeCompare(b.file);
    }
    return b.file.localeCompare(a.file);
  });

  const handleSortOrderChange = () => {
    setSortOrder(prevOrder => (prevOrder === 'asc' ? 'desc' : 'asc'));
  };

  return (
    <div>
    {isUserAdminn && (
      <>
    <Box sx={{ padding: '20px' }}>
      <Typography variant="h4" gutterBottom>Logs</Typography>
      <Box sx={{ marginBottom: '10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <TextField
          label="Filtrar logs"
          variant="outlined"
          fullWidth
          margin="normal"
          value={filter}
          onChange={e => setFilter(e.target.value)}
        />
        <IconButton onClick={handleSortOrderChange} size="small" sx={{ marginLeft: '10px' }}>
          <Sort />
        </IconButton>
        <Button onClick={fetchActiveUsers} variant="contained" sx={{ marginLeft: '10px' }}>
          Listar Usuários Ativos
        </Button>
      </Box>
      {sortedLogs.map((log, index) => (
        <Accordion key={index}>
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography>{log.file}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography component="pre" style={{ whiteSpace: 'pre-wrap' }}>
              {log.log.join('')}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
      
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>Usuários Ativos</DialogTitle>
        <DialogContent>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID do Usuário</TableCell>
                <TableCell>E-mail</TableCell>
                <TableCell>Nome de Usuário</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {activeUsers.map((user, index) => (
                <TableRow key={index}>
                  <TableCell>{user.user_id}</TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>{user.username}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Fechar</Button>
        </DialogActions>
      </Dialog>
    </Box>
    </>
            )}

            {!isUserAdminn && (
                <Typography variant="h6" color="error">
                    Você não tem permissão para acessar esta página.
                </Typography>
            )}
  </div>
  );
};

export default LogViewer;
